// web/src/store/phone/phone-number.ts —— 对外：normalizePhone（号码归一，与后端同口径）
// 拆自 web/src/store/phone.ts 的同名分区（内容原样搬运）；由 web/src/store/phone.ts 以 export * 聚合，导出面对调用方不变。

/** 归一化电话号码（与后端 crm.normalizePhone 同口径）：去 +86/0086/空格/连字符/括号 */
export function normalizePhone(p: string): string {
  const digits = (p || '').replace(/[^\d]/g, '');
  if (digits.length > 11 && (digits.startsWith('86') || digits.startsWith('0086'))) {
    return digits.startsWith('0086') ? digits.slice(4) : digits.slice(2);
  }
  return digits;
}
